import moment from 'moment-timezone';

export const formatDateTimeZone = (date, timeZone, format = '') => {
  if (!timeZone) return null;
  return moment(date).tz(timeZone).format(format);
};
